import { Table, Text } from '@mantine/core';

import { dictionaryTypes } from '../../types';

import { TaskTypeAction } from './TaskTypeAction';

type Props = {
  taskType: dictionaryTypes.TaskType;
};

export const TaskTypesRow = ({ taskType }: Props) => {
  return (
    <Table.Tr>
      <Table.Td>
        <Text size="sm">{taskType.text}</Text>
      </Table.Td>
      <Table.Td>
        <TaskTypeAction _id={taskType._id} isArchived={Boolean(taskType.archivedAt)} />
      </Table.Td>
    </Table.Tr>
  );
};
